import './comp_slider_box.css'

const Comp_Slider_Box=(props)=>{
    return(
        <div id="activitySlider" class="carousel slide sliderboxx">
          
          <div class="carousel-inner">
          {props.liveTicker.map((item,index)=>{
return  <div class="carousel-item active">
<div class="slider-box d-flex flex-column justify-content-center text-center">
  <div class="live-badge d-flex align-items-center gap-1">
    <div class="live-dot"></div>
    LIVE
  </div>
  <h4>Express oil change done</h4>
  <p class="mb-0">
    {"Oil change completed "+ item["time_ago"]+" "} {" at "+item["business_name"]+", "+item["city_name"]+", "+item["state_name"]}
  </p>
</div>
          </div>
          })}
           

         

        
            
          </div>

         
          <div class="carousel-indicators">
            <button type="button" data-bs-target="#activitySlider" data-bs-slide-to="0" class="active"></button>
            <button type="button" data-bs-target="#activitySlider" data-bs-slide-to="1"></button>
          </div>
        </div>
    );
}

export default Comp_Slider_Box;